export default [
  {
    path: '/referrals',
    component: () => import(/* webpackChunkName: "providers" */ './components/Main.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
    },
  },
];
